import React, { useState, useEffect } from 'react';

const TIMEOUT_MS = 12000;

/**
 * Minimal fallback for Suspense: small spinner + "Loading...".
 * After TIMEOUT_MS shows "Retry" so the user is not stuck.
 */
const LoaderWithTimeout = () => {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setTimedOut(true), TIMEOUT_MS);
    return () => clearTimeout(t);
  }, []);

  if (timedOut) {
    return (
      <div style={{
        background: '#000',
        height: '100vh',
        width: '100%',
        maxWidth: 430,
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        boxSizing: 'border-box',
      }}>
        <p style={{ color: '#fff', marginBottom: 16, textAlign: 'center' }}>
          Page is taking too long to load.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '12px 24px',
            background: '#3b82f6',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
            fontSize: 16,
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  const imageSrc = `${process.env.PUBLIC_URL || ''}/images/ice-button.webp`;

  return (
    <div style={{
      background: '#000',
      height: '100vh',
      width: '100%',
      maxWidth: 430,
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        position: 'relative',
        width: 140,
        height: 140,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '4px solid rgba(59, 130, 246, 0.2)',
          borderTopColor: '#3b82f6',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        <img
          src={imageSrc}
          alt=""
          style={{
            width: 100,
            height: 'auto',
            position: 'relative',
            zIndex: 1,
          }}
        />
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default LoaderWithTimeout;
